import { ENABLED_CATEGORIES } from './route.types'

export const NEWSLETTER_CUSTOM_ID = {
  [ENABLED_CATEGORIES.OTHER]: 'pozostale-pl',
  [ENABLED_CATEGORIES.INTERSHIP]: 'praktyki-staze-pl',
  [ENABLED_CATEGORIES.SERVICES]: 'obsluga-pl',
  [ENABLED_CATEGORIES.SELL]: 'sprzedaz-pl',
  [ENABLED_CATEGORIES.TECHNOLOGIES]: 'technologie-pl',
  [ENABLED_CATEGORIES.ALL_OFFERS]: 'wszystkie-oferty-pl',
}
